<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            v-bind:style="{'display': isExportPro ? 'none' : 'block'}"
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.id }}</td>
                <td><img :src="(item.mikobi_id ? 'https://mikobihouse.com/' : 'https://trangkem.com/')+item.path" alt="" style="height: 56px; width: 56px;"></td>
                <td> {{ item.product_code }} <br/><a v-if="item.mikobi_id" target="_blank" :href="'https://mikobihouse.com/chi-tiet-san-pham/'+item.mikobi_id">(MikobiHouse)</a></td>
                <td> {{ item.name }}</td>
                <td class="text-end">{{ item.price | currency }}</td>
                <td class="text-end">{{ item.qty | currency }}</td>
                <td class="text-center">
                  <v-icon medium :color="item.is_active ? 'green' : 'red'">circle</v-icon>
                </td>
                <td>
                  {{ item.created_at | display_date("DD-MM-YYYY") }}
                  <br />
                  {{ item.created_at | display_date("HH:mm:ss") }}
                </td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="openItem(item.id)">edit</v-icon>
                  <v-icon medium class="mr-2" @click="copyItem(item.id)">content_copy</v-icon>
                  <v-icon medium class="mr-2" @click="openComment(item.id)">chat</v-icon>
                  <v-icon medium @click="deleteItem(item.id)" v-if="adminRole">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div class="row shop_wrapper" v-if="total_page && isExportPro">
            <div class="col-lg-3 col-md-4 col-6 " v-for="(item, index) in items" :key="index">
                <div class="single_product">
                    <div class="product_thumb">
                        <a class="primary_img" @click="gotoDetail(item.id)"><img :src="(item.mikobi_id ? 'https://mikobihouse.com/' : 'https://trangkem.com/')+item.path" alt=""></a>
                    </div>

                    <div class="product_content grid_content">
                        <div class="content_inner">
                            <div class="product_name">
                                <h3><a @click="openItem(item.id)">{{ item.name }}</a></h3>
                            </div>
                            <div class="product_code">
                                <h3><a @click="openItem(item.id)">Mã sản phầm: {{ item.product_code }}</a></h3>
                                <h3 v-if="item.made_in">Xuất xứ: {{ item.made_in }}</h3>
                                <h3>Tồn kho: {{ item.qty | currency }}</h3>
                            </div>
                            <div class="price_box">
                                <span class="current_price">{{ item.price | currency }}</span>
                            </div>
                            <div class="price_box">
                                <span class="old_price text-red">{{ !item.is_active ? 'Đã mua hàng' : '' }}</span>
                            </div>
                            <div class="text-center">
                              <v-icon medium class="mr-6" @click="openItem(item.id)">edit</v-icon>
                              <v-icon medium class="mr-6" @click="copyItem(item.id)">content_copy</v-icon>
                              <v-icon medium class="mr-6" @click="openComment(item.id)">chat</v-icon>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-lg-12 shop_toolbar t_bottom">
              <v-pagination v-model="pagination.page" :length="total_page" :total-visible="5" ></v-pagination>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <comment-box :dialogComment="dialogComment" :productId="selectedProductId" @closePopup="dialogComment=false"></comment-box>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import comment from "@/components/popups/comment";
import { isMobileAgent } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "comment-box": comment,
    "hpo-filter": Filtering,
  },
  data() {
    return {
      viewName: "product_list",
      dialogItem: false,
      dialogComment: false,
      selectedProductId: 0,
      headers: [
        {
          text: "ID",
          value: "id",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Hình ảnh",
          value: "path",
          width: "120px",
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã sản phẩm",
          value: "product_code",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên sản phẩm",
          value: "name",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Đơn giá",
          value: "price",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tồn kho",
          value: "qty",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Trạng thái",
          value: "is_active",
          width: "120px",
          filterable: true,
          values: configs.ACTIVE_LIST,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "Ngày tạo",
          value: "created_at",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"],
        },
        {
          text: "",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
          width: "180px"
        },
      ],
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."]
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    },
    currentPath() {
      this.filter_data();
    }
  },
  computed: { 
    ...mapState({
      items: (state) => state.products.all.data,
      total_rows: (state) => state.products.all.total,
      loading: (state) => state.products.loading,
      currentItem: (state) => state.products.selected
    }),
    isMobile: isMobileAgent,
    currentPath() {
      return this.$route.path;
    },
    adminRole() {
      return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
    },
    staffRole() {
      return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Staff;
    },
    total_page() {
      return Math.ceil(this.total_rows/this.pagination.itemsPerPage);
    },
    isExportPro() {
      return this.currentPath && this.currentPath.includes('san-pham-xuat');
    }
  },
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: [...this.filterConditions],
        quickFilter: this.quickFilterConditions,
      };
      if(this.currentPath && this.currentPath.includes('san-pham-xuat')) {
        param.filter.push({column: 'pro_type', value: 1, condition: "equal"});
      }
      else {
        param.filter.push({column: 'pro_type', value: 1, condition: "does_not_equal"});
      }
      this.$store.dispatch("products/getList", param);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    openItem: function (id) {
      this.$router.push({
        name: this.currentPath && this.currentPath.includes('san-pham-xuat') ? "ExportProductDetail" : "ProductDetail",
        params: { Pid: id || 'tao-moi', title: `Chi tiết sản phẩm` }
      });
    },
    copyItem(id) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'Duplicate', id, `Bạn có chắc chắn <b class='red--text'>sao chép</b> sản phẩm có id = ${id} không?`);
    },
    openComment(id) {
      this.dialogComment = true;
      this.selectedProductId = id;
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'Delete', id, `Bạn có chắc chắn <b class='red--text'>xoá</b> sản phẩm có id = ${id} không?`);
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      this.$store.dispatch("products/removeDetail", id);
    });
    this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
      if(action == 'Duplicate') {
        this.$store.dispatch("products/copyDetail", id);
      }
      else if(action == 'Delete') {
        this.$store.dispatch("products/removeDetail", id);
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    this.$root.$off("CONFIRMED_ACTION");
  },
};
</script>
